import React, { useState } from "react";
import {
    FaBookOpen,
    FaChalkboardTeacher,
    FaClipboardList,
    FaUsers,
    FaTrophy,
    FaLayerGroup,
    FaMobile,
    FaCloud,
    FaChartLine,
    FaBrain,
    FaRocket,
    FaShield,
    FaPlay,
    FaCheck,
    FaArrowRight,
    FaStar,
    FaDownload
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const FeaturesPage = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0);

    const mainFeatures = [
        {
            icon: <FaBookOpen className="mx-auto text-4xl text-[#2148C0] mb-4" />,
            title: "Past Questions Bank",
            description: "Practice with questions modeled in line with JAMB, WAEC, and NECO standards — giving you the real exam feel without being the exact exam questions.",
            highlight: "Exam Focused"
        },
        {
            icon: <FaChartLine className="mx-auto text-4xl text-[#2148C0] mb-4" />,
            title: "Performance Tracking",
            description: "Monitor your progress with detailed analytics that highlight strengths and areas for improvement across all subjects.",
            highlight: "Smart Analytics"
        },
        {
            icon: <FaClipboardList className="mx-auto text-4xl text-[#2148C0] mb-4" />,
            title: "Smart Quizzes",
            description: "Test your knowledge with AI-powered instant feedback quizzes after each topic to track your progress.",
            highlight: "Instant Feedback"
        },
        {
            icon: <FaLayerGroup className="mx-auto text-4xl text-[#2148C0] mb-4" />,
            title: "Organized Content",
            description: "Explore thousands of questions organized by subject, topic, and class (JSS1 – SS3).",
            highlight: "15+ Subjects"
        },
        {
            icon: <FaUsers className="mx-auto text-4xl text-[#2148C0] mb-4" />,
            title: "Social Learning",
            description: "Compete with friends and students nationwide on class-based and global leaderboards.",
            highlight: "Live Rankings"
        },
        {
            icon: <FaTrophy className="mx-auto text-4xl text-gray-400 mb-4" />, // gray icon
            title: "Gamification (Coming Soon)",
            description: "We are creating something special 🌟",
            highlight: null,
            isComingSoon: true
        },
    ];


    const advancedFeatures = [
        {
            icon: <FaBrain className="text-3xl text-white" />,
            title: "AI-Powered Learning",
            description: "Smart recommendations based on your performance and learning patterns",
            color: "from-purple-500 to-purple-600"
        },
        {
            icon: <FaChartLine className="text-3xl text-white" />,
            title: "Performance Analytics",
            description: "Detailed insights into your strengths, weaknesses, and progress over time",
            color: "from-green-500 to-green-600"
        },
        {
            icon: <FaMobile className="text-3xl text-white" />,
            title: "Mobile Optimized",
            description: "Study anywhere, anytime with our responsive design and offline capabilities",
            color: "from-blue-500 to-blue-600"
        },
        {
            icon: <FaCloud className="text-3xl text-white" />,
            title: "Cloud Sync",
            description: "Your progress syncs across all devices automatically",
            color: "from-indigo-500 to-indigo-600"
        }
    ];

    const featureTabs = [
        {
            title: "For Students",
            content: [
                "Improve your success rate with questions modelled around WAEC, JAMB and NECO",
                "Personalized study recommendations",
                "Progress tracking and performance analytics",
                // "Offline study mode for uninterrupted learning"
            ]
        },
        // {
        //     title: "For Teachers",
        //     content: [
        //         "Assign quizzes and track student progress",
        //         "Access to comprehensive question banks",
        //         "Classroom management tools",
        //         "Student performance reports",
        //         "Collaborative learning features"
        //     ]
        // },
        {
            title: "For Parents",
            content: [
                "Monitor your child's study progress",
                "Receive weekly performance reports",
                "Set study goals and reminders",
                "Track time spent studying",
                "View detailed subject breakdowns"
            ]
        }
    ];

    const testimonials = [
        {
            name: "Adaora O.",
            class: "SS3 Student",
            text: "TeeChaa helped me score 280 in JAMB! The past questions were exactly what I needed.",
            rating: 5
        },
        {
            name: "Ibrahim M.",
            class: "JSS2 Student",
            text: "The interactive quizzes make learning fun. I've improved in Math significantly!",
            rating: 5
        },
        {
            name: "Blessing C.",
            class: "SS1 Student",
            text: "Best study app for Nigerian students. The explanations are so clear!",
            rating: 5
        }
    ];

    return (
        <div className="bg-white">
            {/* Hero Section */}
            <section
                className="py-24 pt-32 text-white relative overflow-hidden"
                style={{
                    backgroundImage: "url('https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                }}
            >
                {/* Dark blue overlay */}
                <div className="absolute inset-0 bg-black/65"></div>


                <div className="container mx-auto px-6 relative z-10">
                    <div className="text-center max-w-4xl mx-auto">
                        <h1 className="text-5xl md:text-7xl font-extrabold mb-6">
                            Powerful Features for
                            <span className="block text-blue-200">Academic Success</span>
                        </h1>
                        <p className="text-xl md:text-2xl mb-8 opacity-90 leading-relaxed">
                            Discover the comprehensive tools and features that make TeeChaa Nigeria's
                            most trusted learning platform for students from JSS1 to SS3.
                        </p>
                        {/* <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <button
                                // onClick={() => navigate("/signup")}
                                className="bg-white text-[#2148C0] px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 flex items-center justify-center gap-2"
                            >
                                <FaRocket /> Start Learning Now
                            </button>
                            <button className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-[#2148C0] transition-all flex items-center justify-center gap-2">
                                <FaPlay /> Watch Demo
                            </button>
                        </div> */}
                    </div>
                </div>

                {/* Floating Elements */}
                <div className="absolute top-20 left-10 w-20 h-20 bg-white bg-opacity-10 rounded-full animate-bounce"></div>
                <div className="absolute bottom-20 right-10 w-16 h-16 bg-blue-200 bg-opacity-20 rounded-full animate-pulse"></div>
                <div className="absolute top-1/2 right-20 w-12 h-12 bg-purple-300 bg-opacity-20 rounded-full animate-bounce" style={{ animationDelay: '1s' }}></div>
            </section>

            {/* Main Features Grid */}
            <section className="py-20 bg-gray-50">
                <div className="container mx-auto px-6">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
                            Everything You Need to Excel
                        </h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            From comprehensive past questions to AI-powered learning recommendations,
                            we've built every feature with your success in mind.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        {mainFeatures.map((feature, index) => (
                            <div
                                key={index}
                                className={`bg-white p-8 rounded-2xl shadow-lg transition-all duration-300 transform group relative overflow-hidden 
        ${feature.isComingSoon
                                        ? "opacity-50 cursor-not-allowed hover:shadow-lg hover:translate-y-0"
                                        : "hover:shadow-xl hover:-translate-y-2"
                                    }`}
                            >
                                {feature.highlight && (
                                    <div className="absolute top-4 right-4 bg-[#2148C0] text-white text-xs px-3 py-1 rounded-full font-semibold">
                                        {feature.highlight}
                                    </div>
                                )}

                                {feature.icon}

                                <h3 className={`text-xl font-semibold mb-3 transition-colors 
        ${feature.isComingSoon ? "text-gray-500" : "group-hover:text-[#2148C0]"}
    `}>
                                    {feature.title}
                                </h3>

                                <p className="text-gray-600 mb-4 leading-relaxed">{feature.description}</p>
                            </div>

                        ))}
                    </div>
                </div>
            </section>

            {/* Advanced Features with Background */}
            <section
                className="py-24 bg-cover bg-center bg-fixed relative"
                style={{
                    backgroundImage: 'url("https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80")'
                }}
            >
                <div className="absolute inset-0 bg-gradient-to-r from-blue-900 to-purple-900 bg-opacity-90"></div>
                <div className="container mx-auto px-6 relative z-10">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl font-bold text-white mb-4">
                            Next-Generation Learning Technology
                        </h2>
                        <p className="text-xl text-blue-100 max-w-3xl mx-auto">
                            Experience the future of education with our cutting-edge features powered by AI and modern technology.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {advancedFeatures.map((feature, index) => (
                            <div
                                key={index}
                                className="text-center p-6 bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl border border-white border-opacity-20 hover:bg-opacity-20 transition-all"
                            >
                                <div className={`w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-r ${feature.color} flex items-center justify-center shadow-lg`}>
                                    {feature.icon}
                                </div>
                                <h3 className="text-lg font-semibold text-white mb-3">{feature.title}</h3>
                                <p className="text-blue-100 text-sm leading-relaxed">{feature.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Interactive Tabs Section */}
            <section className="py-20 bg-white">
                <div className="container mx-auto px-6">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-gray-800 mb-4">Built for Everyone</h2>
                        <p className="text-xl text-gray-600">Tailored features for students, teachers, and parents</p>
                    </div>

                    <div className="max-w-4xl mx-auto">
                        <div className="flex justify-center mb-8 bg-gray-100 p-2 rounded-full">
                            {featureTabs.map((tab, index) => (
                                <button
                                    key={index}
                                    onClick={() => setActiveTab(index)}
                                    className={`px-8 py-3 rounded-full font-semibold transition-all ${activeTab === index
                                        ? 'bg-[#2148C0] text-white shadow-lg'
                                        : 'text-gray-600 hover:text-[#2148C0]'
                                        }`}
                                >
                                    {tab.title}
                                </button>
                            ))}
                        </div>

                        <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl shadow-lg">
                            <h3 className="text-2xl font-semibold mb-6 text-[#2148C0]">
                                {featureTabs[activeTab].title}
                            </h3>
                            <div className="grid md:grid-cols-2 gap-4">
                                {featureTabs[activeTab].content.map((item, index) => (
                                    <div key={index} className="flex items-start gap-3">
                                        <FaCheck className="text-green-500 mt-1 flex-shrink-0" />
                                        <span className="text-gray-700">{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* App Download Section */}
            {/* <section className="py-20 bg-gradient-to-r from-[#2148C0] to-blue-700 text-white">
                <div className="container mx-auto px-6">
                    <div className="max-w-4xl mx-auto text-center">
                        <FaMobile className="text-6xl mx-auto mb-6 opacity-80" />
                        <h2 className="text-4xl font-bold mb-6">Study On The Go</h2>
                        <p className="text-xl mb-8 opacity-90">
                            Download our mobile app and never miss a study session. Available on all platforms.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <button className="bg-white text-[#2148C0] px-8 py-4 rounded-2xl font-semibold hover:bg-gray-100 transition-all flex items-center justify-center gap-3">
                                <FaDownload /> Download for Android
                            </button>
                            <button className="bg-white text-[#2148C0] px-8 py-4 rounded-2xl font-semibold hover:bg-gray-100 transition-all flex items-center justify-center gap-3">
                                <FaDownload /> Download for iOS
                            </button>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* Final CTA */}
            <section className="py-20 bg-white text-center">
                <div className="container mx-auto px-6">
                    <h2 className="text-4xl font-bold text-gray-800 mb-6">
                        Ready to Transform Your Learning Experience?
                    </h2>
                    <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
                        Join over 10,000 students who are already achieving academic excellence with TeeChaa.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <button
                            // onClick={() => navigate("/free-login")}

                            onClick={() => navigate("/signup")}
                            className="bg-[#2148C0] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-blue-700 transition-all transform hover:scale-105 flex items-center justify-center gap-2"
                        >
                            <FaRocket /> Get Started Free
                        </button>
                        <button
                            onClick={() => navigate("/contact-us")}
                            className="border-2 border-[#2148C0] text-[#2148C0] px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#2148C0] hover:text-white transition-all"
                        >
                            Contact Sales
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FeaturesPage;